import { AppBar, IconButton } from "@mui/material";
import { useMemo } from "react";
import { styled } from "@mui/material/styles";
import useStore from "../../store";
import PTMIcon from "../../Components/PTMIcon";

/* eslint-disable-next-line no-undef */
const onBrowser = _isBrowser;

const StyledDiv = styled("div", {
    shouldForwardProp: (prop) => !["onBrowser"].includes(prop),
// eslint-disable-next-line no-shadow
})(({ onBrowser }) => ({
    height: 30,
    borderBottom: "1px solid",
    borderRight: "1px solid",
    "& hr": {
        margin: 0,
    },
    ".icon-button": {
        ...onBrowser ? {
            width: 20,
            position: "absolute",
            right: 10,
            top: 2,
            fontSize: 20,
        } : {
            position: "absolute",
            width: 20,
            left: "50%",
            top: "50%",
            fontSize: 20,
            transform: "translate(-50%, -50%)",
        },
    },
}));

export default function MenuTopLeft() {
    const isCollapsed = useStore((store) => store.menu.isCollapsed);
    const toggleCollapsed = useStore((store) => store.menu.toggleCollapsed);

    return (
        useMemo(() => (
            <StyledDiv>
                <AppBar
                    style={{ display: "inline-grid", height: 30, padding: !onBrowser && "20px 0" }}
                    position="relative"
                >
                    <IconButton
                        className="icon-button"
                        onClick={toggleCollapsed}
                        color="inherit"
                    >
                        <PTMIcon style={{ lineHeight: 0 }} iconStyle={{ fontSize: 20 }} icon="bars" popover="Menü aus-/einklappen" />
                    </IconButton>
                </AppBar>
            </StyledDiv>
        ), [toggleCollapsed, isCollapsed, onBrowser])
    );
}
